import "./DropdownMenu.scss";

interface DropdownMenuProps {
  title?: string,
  inverse?: boolean,
  style?: any,
  closing: boolean,
  children: any,
};

const DropdownMenu = (props: DropdownMenuProps) => {
  return (
    <div
      className={
        'dropdown-wrapper' + (props.inverse ? ' inverse' : '') + '' + (props.closing ? ' closing' : '')
      }
      style={props.style}
    >
      {props.title && props.title.length > 0 && (
        <div className='dropdown-title'>{props.title}</div>
      )}
      <div className='dropdown-content'>
        {props.children}
      </div>
    </div>
  );
};

export default DropdownMenu